import type { TDropdownValue } from '@/pages/datalab/components/DropdownSelect/types';

/** 下拉中「自动」选项的 value，与 DropdownSelect options 保持一致 */
export const AUTO_VALUE = 'auto';

/** 最小值的自定义默认数（从「自动」切到自定义时使用） */
export const CUSTOM_MIN_DEFAULT = 0;
/** 最大值的自定义默认数（从「自动」切到自定义时使用） */
export const CUSTOM_MAX_DEFAULT = 0;

/**
 * 将 DropdownSelect 的 onChange 回传值转为表格用的 number | null
 * 'auto' / '' / null / undefined 视为自动 → null；自定义对象取 customValue；否则取原值
 */
export const parseDropdownValue = (v: TDropdownValue): number | null => {
  if (v === AUTO_VALUE || v === '' || v === null || v === undefined) {
    return null;
  }
  if (v && typeof v === 'object' && (v as any).type === 'custom') {
    const cv = (v as any).customValue;
    return cv !== undefined && cv !== null && cv !== ''
      ? (cv as number)
      : null;
  }
  return typeof v === 'number' && !isNaN(v) && isFinite(v) ? v : null;
};

/**
 * 根据当前 min/max 数字得到传给 DropdownSelect 的 value
 * null/undefined 表示自动 → 传 AUTO_VALUE；否则传 { type: 'custom', customValue }
 */
export const getDropdownValueFromNumber = (
  num: number | null | undefined
): string | { type: 'custom'; customValue: number; } => {
  if (num === null || num === undefined) {
    return AUTO_VALUE;
  }
  return { type: 'custom', customValue: num };
};
